import { urlApiQuiz } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import {
  IBodyAnswerQuestion,
  IBodyCompleteQuiz,
  IBodyStartQuiz,
  IQueryGetQuizDetail,
  IQuizDetail,
} from '~/utils/interface/quiz';
import { ContentTypeEnum } from '~/utils/enum/common';

export const quizApi = {
  getDetailQuiz(params: IQueryGetQuizDetail) {
    return axiosClient.get<IBaseResponse<IQuizDetail>>(urlApiQuiz.detail, { params });
  },

  startQuiz(payload: IBodyStartQuiz) {
    return axiosClient.post<IBaseResponse<IQuizDetail>>(urlApiQuiz.startQuiz, payload);
  },

  answerQuestion(payload: IBodyAnswerQuestion) {
    return axiosClient.post<IBaseResponse<any>>(urlApiQuiz.answerQuestion, payload);
  },

  answerFileQuestion(body: FormData) {
    return axiosClient.post<IBaseResponse<any>>(urlApiQuiz.answerFileQuestion, body, {
      headers: { 'Content-Type': ContentTypeEnum.FORM_DATA },
    });
  },

  completeQuiz(payload: IBodyCompleteQuiz) {
    return axiosClient.post<IBaseResponse<any>>(urlApiQuiz.completeQuiz, payload);
  },
};
